import type { FaireProductEntity } from "../../entity_types/product";

export const p_efvpy2q6eq: FaireProductEntity = {
  token: "p_efvpy2q6eq",
  type: "product",
  name: "Pencil Taper Candles – HB Yellow (2 pack)",
  brandToken: "b_d72c56fe",
  brandName: "54 Celsius",
  imageUrl:
    "https://cdn.faire.com/fastly/e2dfcd39f87d6f696f7f2c69e692da43b2c97b36810cb6404028b3f3976cc060.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b4b920e7cedd09010d448cac0abd5fef6ec4591666cc430874fcd5810a4d257b.jpeg",
    "https://cdn.faire.com/fastly/a3a0a00e12bddcefbdf98b8aceb3048dc91387f7f18251d953917cdff20503b1.jpeg",
    "https://cdn.faire.com/fastly/5364ded8f78a3d4f673db98756de75ecac90293b7c5826921a0fe030aed0aa46.jpeg",
    "https://cdn.faire.com/fastly/4b77f02250d0df09fc6b4c9b55124e335ee9641b4e9c367b55609eed4b6723d2.jpeg",
  ],
  priceDollars: 8.75,
  description:
    "A graphic reinterpretation of the everyday pencil, rendered as a sculptural candle. Finished in a high-impact hue with a contrasting sharpened tip, the Pencil Candle plays with scale, color, and familiarity. Clean lines and a glossy surface give it a bold, contemporary presence, designed to stand out on shelves, tables, or as part of a styled arrangement.\n\nPart of our Proper Wax family of candles: The wax is sustainably sourced from RSO certified growers, and they are produced in a Fairtrade certified workshop providing the primarily female workers with a living wage to support their families.\n\n• Size: 7/8” diameter x 9” high (2.2cm x 23cm)\n• Burn time: 8 hours\n• Weight: 2.8 oz (80 g)\n• Material: Sustainably sourced palm wax (RSO certified) and cotton wick.\n• Handmade in Indonesia.\n• Design by Thorunn Arnadottir",
  tags: [],
  msrpDollars: 17.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:32.240Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
